/**
 * Collection Filters — Ajax filtering, sort, and mobile drawer
 */
(function () {
  'use strict';

  const filterToggle = document.querySelector('[data-filters-toggle]');
  const filterDrawer = document.querySelector('[data-filters-drawer]');
  const filterClose = document.querySelector('[data-filters-close]');
  const filterForm = document.querySelector('[data-filters-form]');
  const sortSelect = document.querySelector('[data-sort-select]');
  const collectionMain = document.querySelector('[data-collection-main]');

  if (!collectionMain) return;

  /* Mobile filter drawer toggle */
  if (filterToggle && filterDrawer) {
    filterToggle.addEventListener('click', () => {
      const isOpen = filterDrawer.classList.toggle('is-open');
      filterToggle.setAttribute('aria-expanded', isOpen);
      filterDrawer.setAttribute('aria-hidden', !isOpen);

      if (isOpen) {
        document.body.style.overflow = 'hidden';
        SixSeven.emit(SixSeven.Events.OVERLAY_SHOW);
      } else {
        document.body.style.overflow = '';
        SixSeven.emit(SixSeven.Events.OVERLAY_HIDE);
      }
    });
  }

  if (filterClose && filterDrawer) {
    filterClose.addEventListener('click', () => {
      filterDrawer.classList.remove('is-open');
      filterDrawer.setAttribute('aria-hidden', 'true');
      if (filterToggle) filterToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      SixSeven.emit(SixSeven.Events.OVERLAY_HIDE);
    });
  }

  /* Close drawer on overlay click */
  SixSeven.on(SixSeven.Events.OVERLAY_HIDE, () => {
    if (filterDrawer && filterDrawer.classList.contains('is-open')) {
      filterDrawer.classList.remove('is-open');
      filterDrawer.setAttribute('aria-hidden', 'true');
      if (filterToggle) filterToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
  });

  /* Build URL from form data */
  function buildFilterURL() {
    const formData = new FormData(filterForm);
    const params = new URLSearchParams();

    for (const [key, value] of formData.entries()) {
      if (value !== '' && value !== '0') {
        params.append(key, value);
      }
    }

    /* Add sort if present */
    if (sortSelect && sortSelect.value) {
      params.set('sort_by', sortSelect.value);
    }

    const baseURL = window.location.pathname;
    const queryString = params.toString();
    return queryString ? `${baseURL}?${queryString}` : baseURL;
  }

  /* Fetch and replace collection content */
  let fetchController = null;

  async function applyFilters() {
    if (fetchController) fetchController.abort();
    fetchController = new AbortController();

    const url = buildFilterURL();

    /* Update URL without reload */
    window.history.replaceState(null, '', url);

    /* Show loading state */
    collectionMain.style.opacity = '0.5';
    collectionMain.style.pointerEvents = 'none';

    try {
      const sectionId = document
        .querySelector('[data-section-id]')
        ?.dataset.sectionId;
      const fetchURL = `${url}${url.includes('?') ? '&' : '?'}section_id=${sectionId}`;

      const res = await fetch(fetchURL, {
        signal: fetchController.signal,
      });
      const html = await res.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');

      /* Replace grid */
      const newMain = parsed.querySelector('[data-collection-main]');
      if (newMain) {
        collectionMain.innerHTML = newMain.innerHTML;
      }

      /* Replace filters (update counts) */
      const newFilters = parsed.querySelector('[data-filters-form]');
      if (newFilters && filterForm) {
        filterForm.innerHTML = newFilters.innerHTML;
      }

      /* Replace filter bar count */
      const newFilterBar = parsed.querySelector('.collection-filters__bar');
      const currentFilterBar = document.querySelector(
        '.collection-filters__bar'
      );
      if (newFilterBar && currentFilterBar) {
        currentFilterBar.innerHTML = newFilterBar.innerHTML;
      }

      /* Scroll to top of grid */
      collectionMain.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (err) {
      if (err.name !== 'AbortError') {
        console.error('Filter fetch failed:', err);
      }
    } finally {
      collectionMain.style.opacity = '';
      collectionMain.style.pointerEvents = '';
    }
  }

  /* Listen for filter changes */
  let filterTimeout;

  if (filterForm) {
    filterForm.addEventListener('change', () => {
      clearTimeout(filterTimeout);
      filterTimeout = setTimeout(applyFilters, 300);
    });

    /* Price range inputs: debounce on input */
    filterForm.addEventListener('input', (e) => {
      if (e.target.type === 'number') {
        clearTimeout(filterTimeout);
        filterTimeout = setTimeout(applyFilters, 800);
      }
    });

    /* Prevent form submit (noscript fallback) */
    filterForm.addEventListener('submit', (e) => {
      e.preventDefault();
      applyFilters();
    });
  }

  /* Sort change */
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      applyFilters();
    });
  }

  /* Handle popstate (back/forward) */
  window.addEventListener('popstate', () => {
    window.location.reload();
  });
})();
